var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"批注预览","visible":_vm.dialogVisible,"width":"75%","top":"10px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('img',{staticClass:"page-img",attrs:{"src":_vm.imgs,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27752426","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Panel/pizhu/detail.vue
// module id = null
// module chunks = 